import { useState } from "react";

const Faqs = ({ Fullfaqs }) => {
  const [faqs, setFaqs] = useState(Fullfaqs.slice(0, 5));
  const [faqIndex, setFaqIndex] = useState(-1);

  const handleFaqClick = (index) => {
    if (faqIndex === index) {
      setFaqIndex(-1);
    } else {
      setFaqIndex(index);
    }
  };

  return (
    <div>
      {" "}
      <ul className="accordion">
        {faqs.map((faq, index) => (
          <li key={index}>
            <a onClick={() => handleFaqClick(index)}>{faq.question}</a>
            {faqIndex === index && (
              <ul
                style={{
                  width: "100%",
                  background: "#e9e9e9",
                  padding: "10px",
                  listStyleType: "none",
                }}
              >
                <li
                  style={{
                    background: "#e9e9e9",
                  }}
                >
                  {faq.answer}
                </li>
              </ul>
            )}
          </li>
        ))}
      </ul>
      {faqs.length !== Fullfaqs.length ? (
        <div className="tru_btn_new design-page">
          <button className="btn btn-primary" onClick={() => setFaqs(Fullfaqs)}>
            Read More
          </button>
        </div>
      ) : (
        <div className="tru_btn_new design-page">
          <button
            className="btn btn-primary"
            onClick={() => setFaqs(Fullfaqs.slice(0, 5))}
          >
            Read Less
          </button>
        </div>
      )}
    </div>
  );
};

export default Faqs;
